(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nds-b2b-access-control"] && !Shopify.designMode) return;
  try {
    document.addEventListener('submit', (event) => {
    const action = event.target.getAttribute('action') || '';
    const isLocked = document.body.classList.contains('nds-b2b-locked');
    const isCheckout = event.submitter?.name === 'checkout' || action.includes('/checkout');
    const isAddToCart = action.includes('/cart/add');

    if (isCheckout || (isLocked && isAddToCart)) {
      event.preventDefault();
    }
  }, true);

  document.addEventListener('click', (event) => {
    const checkoutLink = event.target.closest('a[href*="/checkout"]');
    if (checkoutLink) event.preventDefault();
  }, true);
  } catch(e) { console.error(e); }
})();

})();
